/**
 * Whether a layout's whole-ride map starts open: yes on desktop, where there is
 * room beside the summary; no on mobile, where it waits for the button.
 * Read once, when the layout is created, like the store's isMobile getter.
 */
export function initialMapOpen(store) {
  return !store.getters.isMobile;
}
